import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {
    ApiService,
    AuthService,
    BlockAbstractComponent,
    CacheService,
    PageService,
    ParserService
} from '@gallaghercp/core-frontend';
import {TranslateService as TranslateProvider} from "@ngx-translate/core";
import {BsDropdownConfig} from 'ngx-bootstrap/dropdown';
import {BsModalRef, BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {ClientService} from "../../services/client.service";

@Component({
    standalone: false,
    selector: 'core-block-client-language',
    templateUrl: './block-client-language.component.html',
    providers: [{provide: BsDropdownConfig, useValue: {isAnimated: false, autoClose: true}}]
})

export class BlockClientLanguageComponent extends BlockAbstractComponent implements OnInit {
    @ViewChild('languageSelect', {static: true}) languageModal!: TemplateRef<any>;

    languages$: any;
    language: any;
    zone: string = '';
    modalRef?: BsModalRef;

    constructor(
        protected override parser: ParserService,
        protected override auth: AuthService,
        protected override pages: PageService,
        protected modalService: BsModalService,
        protected cache: CacheService,
        public client: ClientService,
        protected api: ApiService
    ) {
        super(parser, auth, pages);
    }

    override ngOnInit() {
        super.ngOnInit();
        this.translateService.getLanguages().subscribe(languages => {
            this.languages$ = languages;
            const lang = (this.translateService.getCurrentLanguage() || 'en') as string;
            this.translateProvider.use(lang);
            this.client.$languageChange.next(lang);
        });
        this.checkLanguageSet();
    }

    getCurrentLanguage(): string {
        return (this.translateService.getCurrentLanguage() || 'en') as string;
    }

    prettifyLanguageCode(code: string) {
        switch (code) {
            default:
                return code;
            case 'en_GB':
                return 'en';
        }
    }

    setLanguage(language: { code: string }) {
        this.client.$languageChange.next(language.code);
        this.translateService.setCurrentLanguage(language.code);
        this.translateProvider.use(language.code);
        this.closeModal();
    }

    checkLanguageSet() {
        this.zone = this.api.getServiceZone();
        if (!this.cache.getFromStorage('currentLanguage') && (this.zone == '3')) {
            this.openModal(this.languageModal);
        }
    }

    openModal(template: TemplateRef<any>) {
        this.modalRef = this.modalService.show(template) || undefined;
    }

    closeModal() {
        if (this.modalRef) {
            this.modalRef.hide();
        }
    }

}
